import { render, staticRenderFns } from "./SitesTable.vue?vue&type=template&id=c90417a0&scoped=true&"
import script from "./SitesTable.vue?vue&type=script&lang=js&"
export * from "./SitesTable.vue?vue&type=script&lang=js&"
import style0 from "./SitesTable.vue?vue&type=style&index=0&id=c90417a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90417a0",
  null
  
)

export default component.exports